var $d63da6b1e3b1db3a$exports = {};
$d63da6b1e3b1db3a$exports = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{5C0B}\u{689D}\u{4EF6}`
};


export {$d63da6b1e3b1db3a$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
